/* Brand layer behaviour.
 * 1. Flags the header once the page has scrolled, so the floating pill can
 *    tighten and raise its opacity.
 * 2. Reveals sections as they enter the viewport.
 *
 * IMPORTANT: Horizon does not scroll the window. Content scrolls inside
 * div.page-wrapper (overflow:auto), so window.scrollY stays at 0 forever and
 * a window scroll listener never fires. Everything below reads the real
 * scroller and falls back to the window only if that element is missing.
 */
(function () {
  'use strict';

  var wrapper = document.querySelector('.page-wrapper');

  /* Which element actually scrolls depends on viewport: on desktop Horizon
     scrolls .page-wrapper, on phones it scrolls the document. Never hardcode
     one of them - measure instead. */
  var wrapperScrolls = function () {
    return !!wrapper && wrapper.scrollHeight - wrapper.clientHeight > 1;
  };

  var scrollTop = function () {
    var a = wrapperScrolls() ? wrapper.scrollTop : 0;
    var b = window.scrollY || document.documentElement.scrollTop || 0;
    return a > b ? a : b;
  };

  /* Capture phase, because scroll events do not bubble - this catches the
     event whichever element emits it. */
  var onScrollOf = function (handler) {
    document.addEventListener('scroll', handler, { passive: true, capture: true });
  };

  /* -------- header state -------- */
  var header = document.getElementById('header-component');
  if (header) {
    var THRESHOLD = 24;
    var ticking = false;

    var apply = function () {
      ticking = false;
      header.classList.toggle('is-scrolled', scrollTop() > THRESHOLD);
    };

    onScrollOf(function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    });

    apply();
  }

  /* -------- scroll reveal --------
   * The hidden state is gated on the b-js class, so if this script never runs
   * the page renders fully visible instead of blank. A reveal that depends on
   * JS must fail open, never closed.
   */
  var root = document.documentElement;
  var targets = document.querySelectorAll('[data-reveal]');
  if (!targets.length) return;

  var showAll = function () {
    for (var i = 0; i < targets.length; i++) targets[i].classList.add('b-in');
  };

  if (!('IntersectionObserver' in window)) {
    root.classList.add('b-js');
    showAll();
    return;
  }

  root.classList.add('b-js');

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('b-in');
        io.unobserve(entry.target);
      });
    },
    {
      /* observe against the real scroller, otherwise every section counts as
         visible on load and the stagger never plays */
      root: wrapperScrolls() ? wrapper : null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.01
    }
  );

  targets.forEach(function (el) {
    io.observe(el);
  });

  /* Failsafe: anything still hidden after 3s is shown regardless. Guards
   * against a section that never intersects (clipped ancestor, zero-height
   * parent, print, odd viewport). */
  window.setTimeout(showAll, 3000);
})();


/* ============================================================
   FAQ PAGE  -  live filter + index highlighting
   Progressive enhancement only. Without this file every question
   is present, expandable and findable by the browser's own
   in-page search; this just makes 26 of them navigable.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-faq-root]');
  if (!root) return;

  var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));
  var links = Array.prototype.slice.call(root.querySelectorAll('.b-faqp__nav a'));
  var input = root.querySelector('[data-faq-search]');
  var clearBtn = root.querySelector('[data-faq-clear]');
  var count = root.querySelector('[data-faq-count]');
  var empty = root.querySelector('[data-faq-empty]');

  var linkFor = {};
  links.forEach(function (a) {
    linkFor[a.getAttribute('href').slice(1)] = a;
  });

  /* -------- filter -------- */
  var hadQuery = false;

  function filter() {
    var q = (input.value || '').trim().toLowerCase();
    var words = q ? q.split(/\s+/) : [];
    var shown = 0;

    items.forEach(function (item) {
      var hay = item.getAttribute('data-text') || '';
      var hit = words.every(function (w) { return hay.indexOf(w) !== -1; });

      item.hidden = !hit;
      if (hit) shown++;

      if (words.length) {
        /* While filtering, show the answer straight away - the visitor has
           already told us what they are looking for. */
        item.open = hit;
      } else if (hadQuery) {
        item.open = false;
      }
    });

    groups.forEach(function (g) {
      var any = g.querySelector('[data-faq-item]:not([hidden])');
      g.hidden = !any;
      var a = linkFor[g.id];
      if (a) a.classList.toggle('is-off', !any);
    });

    if (clearBtn) clearBtn.hidden = words.length === 0;
    if (empty) empty.hidden = !(words.length && shown === 0);

    if (count) {
      if (words.length) {
        count.hidden = false;
        count.textContent = shown === 1
          ? '1 question matches'
          : shown + ' questions match';
      } else {
        count.hidden = true;
        count.textContent = '';
      }
    }

    hadQuery = words.length > 0;
  }

  if (input) {
    input.addEventListener('input', filter);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && input.value) {
        e.preventDefault();
        input.value = '';
        filter();
      }
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      filter();
      input.focus();
    });
  }

  /* A back/forward restore can hand us a populated field, so sync once. */
  if (input && input.value) filter();

  /* -------- jump links --------
   * Native fragment navigation does nothing in this theme. The document
   * itself does not scroll - .page-wrapper does - and the browser never
   * scrolls that container for a #hash, so every rail link would look
   * broken while quietly changing the URL. Scroll it ourselves, and apply
   * the header offset here rather than relying on scroll-margin, which is
   * only consulted by the navigation that is not happening.
   */
  var HEADER_OFFSET = 110;

  function scrollerEl() {
    var w = document.querySelector('.page-wrapper');
    if (w && w.scrollHeight - w.clientHeight > 1) return w;
    return document.scrollingElement || document.documentElement;
  }

  function jumpTo(target, smooth) {
    var sc = scrollerEl();
    var isDoc = sc === document.scrollingElement || sc === document.documentElement;
    var containerTop = isDoc ? 0 : sc.getBoundingClientRect().top;
    var top = target.getBoundingClientRect().top - containerTop + sc.scrollTop - HEADER_OFFSET;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var opts = { top: Math.max(0, top), behavior: smooth && !reduce ? 'smooth' : 'auto' };

    if (isDoc) window.scrollTo(opts);
    else sc.scrollTo(opts);

    /* Move focus too, or a keyboard user activates the link and stays put. */
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;
      var target = document.getElementById(id.slice(1));
      if (!target) return;
      e.preventDefault();
      jumpTo(target, true);
      if (history.replaceState) history.replaceState(null, '', id);
    });
  });

  /* Deep link from another page - same reason, same fix. */
  if (location.hash.length > 1) {
    var deep = document.getElementById(location.hash.slice(1));
    if (deep && deep.hasAttribute('data-faq-group')) {
      window.requestAnimationFrame(function () { jumpTo(deep, false); });
    }
  }

  /* -------- index highlighting --------
   * Measured rather than observed. An IntersectionObserver only reports the
   * moment a group crosses the band, so once you scroll back above the first
   * group nothing fires and the rail keeps highlighting whatever was last
   * seen. Reading positions answers "which group am I in" directly, and
   * getBoundingClientRect is viewport-relative either way - so this needs no
   * opinion about whether .page-wrapper or the document is doing the
   * scrolling.
   */
  if (!links.length) return;

  var ACTIVE_LINE = 140;
  var ticking = false;

  function markCurrent() {
    ticking = false;

    var active = null;
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].hidden) continue;
      if (!active) active = groups[i];
      if (groups[i].getBoundingClientRect().top <= ACTIVE_LINE) active = groups[i];
    }

    var current = active ? linkFor[active.id] : null;
    links.forEach(function (l) { l.classList.toggle('is-current', l === current); });
  }

  document.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(markCurrent);
  }, { passive: true, capture: true });

  window.addEventListener('resize', markCurrent, { passive: true });
  markCurrent();
})();


/* ============================================================
   SHARED SCROLL HELPER
   Horizon scrolls .page-wrapper on desktop and the document on
   phones, and native #hash navigation moves neither. Anything
   that needs to scroll the page goes through here.
   ============================================================ */
window.Brand = window.Brand || {};

window.Brand.scrollerEl = function () {
  var w = document.querySelector('.page-wrapper');
  if (w && w.scrollHeight - w.clientHeight > 1) return w;
  return document.scrollingElement || document.documentElement;
};

window.Brand.scrollToEl = function (el, offset, smooth) {
  var sc = window.Brand.scrollerEl();
  var isDoc = sc === document.scrollingElement || sc === document.documentElement;
  var containerTop = isDoc ? 0 : sc.getBoundingClientRect().top;
  var top = el.getBoundingClientRect().top - containerTop + sc.scrollTop - (offset || 0);
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var opts = { top: Math.max(0, top), behavior: smooth && !reduce ? 'smooth' : 'auto' };

  if (isDoc) window.scrollTo(opts);
  else sc.scrollTo(opts);
};


/* ============================================================
   CONTACT FORM  -  photo attachments + submit guards

   Shopify's contact form cannot carry a file, so the browser
   uploads each photo to the image host on selection and the
   returned URLs are written into a hidden text field that rides
   along with the message.

   Everything here fails open. An upload that errors does not
   block the message; the visitor is told the photo did not make
   it and can still send.
   ============================================================ */
(function () {
  'use strict';

  /* Shopify redirects to #contact_form after a successful post, and that
     anchor does nothing in this theme - the confirmation would sit off
     screen with the page still at the top. Put it in view ourselves. */
  var done = document.querySelector('[data-contact-done]');
  if (done) {
    window.requestAnimationFrame(function () {
      window.Brand.scrollToEl(done, 130, false);
      done.focus({ preventScroll: true });
    });
  }

  var form = document.getElementById('contact_form');
  if (!form) return;

  /* -------- spam guard -------- */
  var honey = form.querySelector('input[name="website"]');

  form.addEventListener('submit', function (e) {
    if (honey && honey.value) e.preventDefault();
  });

  /* -------- uploads -------- */
  var root = form.querySelector('[data-upload]');
  if (!root) return;

  var cloud = root.getAttribute('data-cloud');
  var preset = root.getAttribute('data-preset');
  var maxFiles = parseInt(root.getAttribute('data-max-files'), 10) || 5;
  var maxBytes = (parseInt(root.getAttribute('data-max-mb'), 10) || 8) * 1024 * 1024;

  var input = root.querySelector('[data-file-input]');
  var zone = root.querySelector('[data-drop-zone]');
  var list = root.querySelector('[data-file-list]');
  var status = root.querySelector('[data-upload-status]');
  var hidden = root.querySelector('[data-photo-urls]');
  var submit = form.querySelector('[data-contact-submit]');

  var items = [];
  var pending = 0;

  function say(message, isError) {
    if (!status) return;
    if (!message) {
      status.hidden = true;
      status.textContent = '';
      status.classList.remove('is-error');
      return;
    }
    status.hidden = false;
    status.textContent = message;
    status.classList.toggle('is-error', !!isError);
  }

  function syncHidden() {
    var urls = [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].url) urls.push(items[i].url);
    }
    hidden.value = urls.join('\n');
  }

  /* Sending while a photo is still in flight would drop it silently. */
  function lock() {
    if (submit) submit.disabled = pending > 0;
  }

  function makeRemove(rec) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'b-drop__x';
    btn.setAttribute('aria-label', 'Remove photo');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
      'stroke-linecap="round" aria-hidden="true" focusable="false">' +
      '<path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';

    btn.addEventListener('click', function () {
      var at = items.indexOf(rec);
      if (at > -1) items.splice(at, 1);
      rec.li.remove();
      syncHidden();
      say('');
    });

    rec.li.appendChild(btn);
  }

  function upload(file) {
    var li = document.createElement('li');
    li.className = 'b-drop__item is-busy';

    var preview = URL.createObjectURL(file);
    var img = document.createElement('img');
    img.src = preview;
    img.alt = '';
    li.appendChild(img);

    var spin = document.createElement('span');
    spin.className = 'b-drop__spin';
    spin.textContent = 'sending';
    li.appendChild(spin);

    list.appendChild(li);

    var rec = { li: li, url: null };
    items.push(rec);
    pending++;
    lock();

    var body = new FormData();
    body.append('file', file);
    body.append('upload_preset', preset);

    fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloud) + '/image/upload', {
      method: 'POST',
      body: body
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var url = data.secure_url || data.url;
        if (!url) throw new Error('no url');
        rec.url = url;
        li.classList.remove('is-busy');
        spin.remove();
        makeRemove(rec);
        syncHidden();
      })
      .catch(function () {
        li.classList.remove('is-busy');
        li.classList.add('is-failed');
        spin.textContent = 'failed';
        makeRemove(rec);
        say('That photo did not upload. You can still send the message - we will ask you for it by email.', true);
      })
      .finally(function () {
        pending--;
        lock();
        URL.revokeObjectURL(preview);
      });
  }

  function addFiles(fileList) {
    var files = Array.prototype.slice.call(fileList || []);
    var rejected = 0;
    var full = false;

    files.forEach(function (file) {
      if (items.length >= maxFiles) {
        full = true;
        return;
      }
      if (file.type.indexOf('image/') !== 0) {
        rejected++;
        return;
      }
      if (file.size > maxBytes) {
        rejected++;
        return;
      }
      upload(file);
    });

    if (full) {
      say('That is the limit of ' + maxFiles + ' photos. Remove one to add another.', true);
    } else if (rejected) {
      say(
        rejected +
          (rejected === 1 ? ' file was skipped' : ' files were skipped') +
          ' - photos only, under ' +
          Math.round(maxBytes / 1048576) +
          'MB each.',
        true
      );
    }
  }

  input.addEventListener('change', function () {
    addFiles(input.files);
    /* Cleared so picking the same file twice still fires a change event. */
    input.value = '';
  });

  ['dragenter', 'dragover'].forEach(function (name) {
    zone.addEventListener(name, function (e) {
      e.preventDefault();
      zone.classList.add('is-over');
    });
  });

  ['dragleave', 'dragend', 'drop'].forEach(function (name) {
    zone.addEventListener(name, function () {
      zone.classList.remove('is-over');
    });
  });

  zone.addEventListener('drop', function (e) {
    e.preventDefault();
    if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
  });

  /* Dropping anywhere else on the page must not navigate away from a
     half-written message. */
  ['dragover', 'drop'].forEach(function (name) {
    window.addEventListener(name, function (e) {
      if (zone.contains(e.target)) return;
      e.preventDefault();
    });
  });
})();


/* ============================================================
   PRODUCT HERO
   Gallery, pack picker and the phone buy bar.

   Everything here upgrades markup that already works: the gallery
   is a native scroll-snap track, and every pack is a real link to
   ?variant=<id>. With this file missing the page still sells - it
   reloads instead of updating in place.

   Wording (Save, each) is read off data attributes the section
   wrote, so the labels stay editable in one place.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-ph]');
  if (!root) return;

  var list = function (sel, ctx) {
    return Array.prototype.slice.call((ctx || root).querySelectorAll(sel));
  };

  /* Set by the gallery below. Left null when there is nothing to scroll -
     one photo, or no stage at all - and every caller checks first. */
  var showImage = null;

  /* -------------------------------------------------- gallery */
  (function gallery() {
    var stage = root.querySelector('[data-ph-stage]');
    if (!stage) return;

    var shots = list('[data-ph-shot]', stage);
    var thumbs = list('[data-ph-thumb]');
    var prev = root.querySelector('[data-ph-prev]');
    var next = root.querySelector('[data-ph-next]');
    if (shots.length < 2) return;

    /* Each shot is exactly one stage wide, so the index is the scroll
       offset over the track width - no per-element measuring. */
    function current() {
      var w = stage.clientWidth || 1;
      return Math.min(shots.length - 1, Math.max(0, Math.round(stage.scrollLeft / w)));
    }

    /* Stepping to a neighbour animates; jumping across the strip from a
       thumbnail does not - sliding through seven photos to reach the eighth
       reads as lag rather than as motion. */
    function goTo(i, smooth) {
      var target = Math.min(shots.length - 1, Math.max(0, i));
      stage.scrollTo({ left: target * stage.clientWidth, behavior: smooth ? 'smooth' : 'instant' });
    }

    var strip = thumbs.length ? thumbs[0].parentNode : null;

    /* Videos, kept beside the index of the slide they live on. A strip of
       nine photographs and one clip should not pay for a querySelector on
       every scroll frame. */
    var vids = [];
    shots.forEach(function (shot, n) {
      var el = shot.querySelector('video');
      if (!el) return;
      el.setAttribute('playsinline', '');
      el.muted = true;
      vids.push({ i: n, el: el });
    });
    var still = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* Off the active slide a clip is noise: it keeps running behind a
       photograph the customer is already looking at. On the active slide a
       five-second muted loop is worth starting by itself - the play button
       is a step almost nobody takes. Muted because every browser refuses
       autoplay with sound, and skipped outright when the visitor has asked
       the system for less motion. */
    function syncVideos(i) {
      for (var n = 0; n < vids.length; n++) {
        var v = vids[n];
        if (v.i === i) {
          if (v.el.paused && !still.matches) {
            var play = v.el.play();
            if (play && play.catch) play.catch(function () {});
          }
        } else if (!v.el.paused) {
          v.el.pause();
        }
      }
    }

    /* The strip scrolls horizontally and holds every photo, so the highlight
       can end up off-screen - which reads as nothing having happened. Its own
       scrollLeft is moved rather than scrollIntoView(), which would drag the
       whole page with it.

       scrollLeft is assigned rather than scrollTo({behavior:'smooth'}):
       measured, a smooth scroll issued here in the same frame as the stage's
       own programmatic scroll is silently dropped - correct numbers, no scroll
       event, nothing moves. Instant is the honest behaviour anyway, since a
       pack click is a jump rather than a trip past nine unrelated photos. */
    function revealThumb(t) {
      if (!strip || !t) return;
      var left = t.offsetLeft;
      var right = left + t.offsetWidth;
      var pad = 12;

      if (left - pad < strip.scrollLeft) {
        strip.scrollLeft = Math.max(0, left - pad);
      } else if (right + pad > strip.scrollLeft + strip.clientWidth) {
        strip.scrollLeft = right + pad - strip.clientWidth;
      }
    }

    function paint() {
      var i = current();
      if (vids.length) syncVideos(i);
      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) revealThumb(t);
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === shots.length - 1;
    }

    var ticking = false;
    stage.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          paint();
        });
      },
      { passive: true }
    );

    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () {
        goTo(n, Math.abs(n - current()) === 1);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(current() - 1, true);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        goTo(current() + 1, true);
      });
    }

    /* The track is focusable, so the arrow keys have to move it. */
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(current() + 1, true);
      }
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(current() - 1, true);
      }
    });

    /* Addressed by image id, not by slide number: reordering the media in the
       admin or adding a photo must not silently point a pack at the wrong
       picture. */
    showImage = function (id, smooth) {
      if (!id) return;
      var wanted = Array.isArray(id) ? id : [id];
      for (var i = 0; i < shots.length; i++) {
        var mine = [shots[i].getAttribute('data-image-id'), shots[i].getAttribute('data-media-id')];
        for (var w = 0; w < wanted.length; w++) {
          if (!wanted[w]) continue;
          if (mine.indexOf(String(wanted[w])) !== -1) {
            if (i !== current()) goTo(i, smooth);
            return;
          }
        }
      }
    };

    window.addEventListener('resize', paint);
    paint();
  })();

  /* ---------------------------------------------- pack picker */
  var packs = list('[data-ph-pack]');
  var input = root.querySelector('[data-ph-variant-input]');

  var saveLabel = root.getAttribute('data-save-label') || '';
  var eachLabel = root.getAttribute('data-each-label') || '';

  var now = root.querySelector('[data-ph-now]');
  var was = root.querySelector('[data-ph-was]');
  var save = root.querySelector('[data-ph-save]');
  var each = root.querySelector('[data-ph-each]');
  var flag = root.querySelector('[data-ph-flag]');
  var flagText = root.querySelector('[data-ph-flag-text]');
  var atc = root.querySelector('[data-ph-atc]');
  var stickyTitle = root.querySelector('[data-ph-sticky-title]');
  var stickyPrice = root.querySelector('[data-ph-sticky-price]');
  var stickyWas = root.querySelector('[data-ph-sticky-was]');
  var stickySave = root.querySelector('[data-ph-sticky-save]');
  var stickyPacks = list('[data-ph-spack]');
  var stickyBtn = root.querySelector('[data-ph-sticky] button[type="submit"]');
  var stickyThumb = root.querySelector('[data-ph-sticky-thumb]');
  var atcMedia = root.querySelector('[data-ph-atc-media]');

  function show(el, on) {
    if (!el) return;
    if (on) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  function join(a, b) {
    return b ? a + ' ' + b : a;
  }

  function select(card, focus) {
    if (!card || !input) return;

    input.value = card.getAttribute('data-variant-id') || input.value;

    packs.forEach(function (c) {
      var on = c === card;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-checked', on ? 'true' : 'false');
      c.setAttribute('tabindex', on ? '0' : '-1');
    });
    if (focus) card.focus();

    var price = card.getAttribute('data-price') || '';
    var compare = card.getAttribute('data-compare') || '';
    var saving = card.getAttribute('data-save') || '';
    var unit = card.getAttribute('data-each') || '';
    var title = card.getAttribute('data-title') || '';
    var available = card.getAttribute('data-available') !== 'false';

    if (now) now.textContent = price;

    if (was) {
      was.textContent = compare;
      show(was, !!compare);
    }

    if (save) {
      save.textContent = saving ? join(saveLabel, saving) : '';
      show(save, !!saving);
    }

    if (each) {
      each.textContent = unit ? join(unit, eachLabel) : '';
      show(each, !!unit);
    }

    if (flag) {
      if (flagText) flagText.textContent = saving ? join(saveLabel, saving) : '';
      show(flag, !!saving);
    }

    if (atc) atc.disabled = !available;
    if (stickyBtn) stickyBtn.disabled = !available;
    if (stickyTitle) stickyTitle.textContent = title;
    if (stickyPrice) stickyPrice.textContent = price;

    if (stickyWas) {
      stickyWas.textContent = compare;
      show(stickyWas, !!compare);
    }

    if (stickySave) {
      stickySave.textContent = saving ? join(saveLabel, saving) : '';
      show(stickySave, !!saving);
    }

    /* The switch in the bar mirrors the cards - it holds no state of its own. */
    var chosenId = card.getAttribute('data-variant-id');
    stickyPacks.forEach(function (b) {
      var on = b.getAttribute('data-variant-id') === chosenId;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.setAttribute('tabindex', on ? '0' : '-1');
    });

    /* The photograph has to agree with the choice: two devices selected,
       two devices on screen. Instant rather than smooth - a pack click is not
       a request to watch the strip slide past nine unrelated photos. */
    if (showImage) showImage([card.getAttribute('data-image-id'), card.getAttribute('data-media-id')], false);

    var thumb = card.getAttribute('data-thumb');
    if (stickyThumb && thumb) stickyThumb.src = thumb;

    /* The fly-to-cart animation reads this attribute when the button is
       pressed, so it flies the pack that is actually being added. */
    var flying = card.getAttribute('data-atc-media');
    if (atcMedia && flying) atcMedia.setAttribute('data-product-variant-media', flying);

    /* Keeps a refresh, a share and the browser's back button on the chosen
       pack rather than silently dropping back to the first one. */
    if (window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', card.getAttribute('data-variant-id'));
        window.history.replaceState({}, '', url.toString());
      } catch (err) {
        /* Older browsers keep the variant on the card's own href. */
      }
    }
    root.dispatchEvent(new CustomEvent('nailnova:pack-change', { bubbles: true }));
  }

  /* Each sticky button resolves to the main card for that variant, so a
     single select() drives the buy box, the bar, the form input and the URL. */
  function cardForVariant(id) {
    for (var i = 0; i < packs.length; i++) {
      if (packs[i].getAttribute('data-variant-id') === id) return packs[i];
    }
    return null;
  }

  stickyPacks.forEach(function (button, i) {
    button.addEventListener('click', function () {
      var card = cardForVariant(button.getAttribute('data-variant-id'));
      if (card) select(card, false);
    });

    button.addEventListener('keydown', function (e) {
      var dir = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
      if (dir === 0) return;

      e.preventDefault();
      var next = stickyPacks[(i + dir + stickyPacks.length) % stickyPacks.length];
      var card = cardForVariant(next.getAttribute('data-variant-id'));
      if (card) select(card, false);
      next.focus();
    });
  });

  packs.forEach(function (card, i) {
    card.addEventListener('click', function (e) {
      e.preventDefault();
      select(card, false);
    });

    card.addEventListener('keydown', function (e) {
      var dir = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;

      if (dir !== 0) {
        e.preventDefault();
        select(packs[(i + dir + packs.length) % packs.length], true);
        return;
      }

      if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        select(card, false);
      }
    });
  });

  /* Keep the first gallery slide on arrival, including variant links.
     Explicit pack choices use select() above to show the matching photo. */

  /* -------------------------------------------------- buy bar */
  (function stickyBar() {
    var bar = root.querySelector('[data-ph-sticky]');
    if (!bar || !atc) return;

    /* Hidden in the markup, so a page without this script never shows a bar
       it would then have no way to hide. */
    bar.removeAttribute('hidden');

    var ticking = false;

    function apply() {
      ticking = false;
      bar.setAttribute('data-stuck', atc.getBoundingClientRect().bottom < 0 ? 'true' : 'false');
    }

    /* Capture phase: scroll does not bubble, and on desktop it is
       .page-wrapper that scrolls rather than the document. */
    document.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(apply);
      },
      { passive: true, capture: true }
    );

    window.addEventListener('resize', apply);
    apply();
  })();

  /* ------------------------------------- links into the page */
  list('[data-ph-jump]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.querySelector(link.getAttribute('data-ph-jump'));
      if (!target || !window.Brand || !window.Brand.scrollToEl) return;
      e.preventDefault();
      window.Brand.scrollToEl(target, 110, true);
    });
  });
})();
